/**
 * Owner: Masa Bayu
 * File: design-tokens.ts
 * Date:Time: 2026-09-15 19:18
 * Description: QXRead T0 design-token foundation names (consume Design System).
 */
/** Semantic token roles — values filled by themes; names locked here. */
export const QXREAD_COLOR_TOKEN_ROLES = [
    'color.text.primary',
    'color.text.secondary',
    'color.bg.canvas',
    'color.bg.elevated',
    'color.border.default',
    'color.border.focus',
    'color.brand.primary',
    'color.publication.paper',
    'color.publication.ink',
];
export const QXREAD_SPACE_TOKEN_ROLES = [
    'space.1',
    'space.2',
    'space.3',
    'space.4',
    'space.6',
    'space.8',
];
export const QXREAD_MOTION_TOKEN_ROLES = [
    'motion.duration.fast',
    'motion.duration.normal',
    'motion.easing.standard',
];
/** §373 QX Responsive UI Standard zones: mobile <768 · tablet 768–1023 · desktop ≥1024. */
export const QXREAD_BREAKPOINT_BANDS = ['mobile', 'tablet', 'desktop'];
export const QXREAD_FOUNDATION_CSS_VARS = {
    textPrimary: '--qx-color-text-primary',
    bgCanvas: '--qx-color-bg-canvas',
    focusRing: '--qx-color-border-focus',
    spaceMd: '--qx-space-4',
    touchMin: '--qx-touch-target-min',
};
/** Accessibility baseline constants for foundation chrome. */
export const QXREAD_A11Y_BASELINE = Object.freeze({
    skipLinkRequired: true,
    focusRingRequired: true,
    minTouchTargetPx: 44,
    reducedMotionRespected: true,
});
//# sourceMappingURL=design-tokens.js.map